import { render, staticRenderFns } from "./NewSectionModal.vue?vue&type=template&id=62dc9c84"
import script from "./NewSectionModal.vue?vue&type=script&lang=js"
export * from "./NewSectionModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports